export const locales = {
  fr: {
    title: "Qui se présente aux élections communales?",
    update: "Mise à jour",
    filter: "Filtrer par parti politique",
    communePlaceholder: "Entrez le nom d'une commune",
    all: "Tous les partis",
    seeAll: "VOIR TOUT",
    closeAll: "TOUT FERMER",
    or: "ou",
    noDataList: "Aucune liste n'a encore été publiée",
    noDataSmall: "Les noms des candidats ne sont pas encore connus",
    firstMandate: "Première candidature",
    age: "Âge",
    function: "Fonction",
    nationality: "Nationalité",
    occupation: "Profession",
    noCommune: "Pas de résultats trouvés pour",
    communeTypeList: "Représentation proportionnelle",
    communeTypeSmall: "Majorité relative",
    noDataAvailable: "Non communiqué",
    footerTitle: "Recherchez les candidats dans d'autres communes",
    lastUpdateDate: "Dernière mise à jour",
    candidates: "Candidats",
    nationalities: {
      be: "Belge",
      fr: "Français",
      de: "Allemand",
      it: "Italien",
      es: "Espagnol",
      lu: "Luxembourgeois",
      nl: "Néerlandais",
      pt: "Portugais",
      gb: "Anglais",
      others: "Autres",
    },
    article: "Article",
    articleTitle: "Newsticker",
    articleForCommune: "Actualités communales",
    coalitionBigCommune: "Coalition",
    coalitionSmallCommune: "Conseil échevinal",
    communeInDetail: "La commune en détail",
    residents: "Habitants",
    numberOfLocalities: "Nombre de localités",
    incumbentMayor: "Bourgmestre actuel",
    typeOfCommune: "Système électoral",
    moreToTheCommune: "Plus sur la commune",
    candidatesForTheCommune: "Les candidats en lice",
    electionInNumbers: "Les élections en chiffres",
    candidatesWomen: "Femmes candidates",
    candidatesForeigners: "Candidats non-luxembourgeois",
    pollingStations: "Bureaux de vote",
    pontetialVoters: "Proportion d'électeurs potentiels inscrits",
    seatsToBeFilled: "Sièges à pourvoir",
    communeInNumbers: "Tout savoir sur la commune",
    politic: "Politique",
    municipalCouncilTitle: "Répartition des sièges au conseil communal",
    municipalCouncilTitleSmallCommune: "Résultats du scrutin de 2017",
    municipalCouncilDescriptionSmallCommune:
      "Données exprimées en valeur absolue",
    municipalCouncilDescription:
      "Données suite aux élections municipales de 2027 en nombre de sièges",
    municipalCouncilByGender: "Répartition femmes/hommes au conseil communal",
    municipalCouncilByGenderDescription: "Données valables au 1er janvier 2023",
    population: "Population",
    populationTitle: "Évolution de la population à ",
    populationDescription:
      "Nombre d'habitants en valeur absolue entre le 1er janvier 1983 et le 1er janvier 2023",
    unemploymentTitle: "Taux de chômage à ",
    unemploymentDescription:
      "Part des chômeurs dans la population active de la commune au 1er janvier entre 2001 et 2023",
    nationalityTitle: "Répartition de la population par nationalité",
    nationalityDescription:
      "Données exprimées en pourcentage au 1er janvier parmi les cinq nationalités les plus représentées",
    agePyramidTitle: "Population par tranche d'âge",
    agePyramidDescription: "Données au 1er janvier 2023",
    housing: "Logement",
    housingPrice: "Prix de l'immobilier",
    housingPriceAverage: "Prix moyen au m² dans la commune",
    housingNationalPriceAverage: "Moyenne nationale",
    housingAreaPurchased: "Surface disponible pour un budget de 500.000 Euros",
    housingVacantHousesPercentage: "Terrains libres dans la commune",
    numberOfVotes: "Nombre de suffrages obtenus",
    votes: "Suffrages",
    isElected: "Élu",
    isNotElected: "Non élu",
    hasCandidate: "a candidaté",
    gender: {
      men: "Hommes",
      women: "Femmes",
    },
    years: "Ans",
    governingParty: "Parti au pouvoir",
    mayor: "Bourgmestre",
    alderman: "Echevin",
    alderwoman: "Echevine",
    references: [
      "Source: Candidatures déposées auprès de la commune",
      "Source: Ministère de la famille",
      "Source: elections.public.lu",
      "Graphiques: Virgule",
      "Source: Statec",
    ],
    unemploymentRate: "Taux de chômage",
    numberOfSeats: "Nombre de sièges",
    electionSystemChanged: "Depuis 2023",
    searchMore: "Rechercher plus de communes",
    results: "Résultats",
    votesPercentage: "Pourcentage de voix",
    votesPercentageParty: "Pourcentage par parti",
    votesDifference:
      "Répartition des sièges au conseil communal en 2023 par rapport à 2017",
    lostVotes: "Siège(s) perdu(s)",
    gainedVotes: "Siège(s) gagné(s)",
    coalitionOptions: "Quelles coalitions sont possibles?",
    previousCandidacies: "Précédentes candidatures",
    noCandidacies: "Pas de candidature",
    votesReceived: "Voix obtenues",
    electedDirectly: "Directement élu(e)",
    numberCandidates: "Nombre de candidats",
    seatsUpForElection: "Personnes à élire",
    councillor: "Conseiller communal",
    womenCouncillor: "Conseillère communale",
    resultsUpdated: "Derrière mise à jour",
    resultsHour: "",
    votesDifferenceMessage:
      "Lors des élections communales de 2017, la commune fonctionnait sous le régime du scrutin majoritaire. Raison pour laquelle le graphique sur les gains et pertes de sièges ne s'affiche pas.",
  },
  de: {
    title: "Wer kandidiert bei den Gemeindewahlen?",
    update: "Letztes Update",
    filter: "Nach Partei filtern",
    communePlaceholder: "Geben Sie einen Gemeindenamen ein",
    all: "Alle Parteien",
    seeAll: "ALLE KANDIDATEN",
    closeAll: "ALLE SCHLIESSEN",
    or: "oder",
    noDataList: "Es wurde noch keine Liste veröffentlicht",
    noDataSmall: "Es gibt noch keine Informationen über die Kandidaten",
    firstMandate: "Erste Kandidatur",
    age: "Alter",
    function: "Funktion",
    nationality: "Nationalität",
    occupation: "Beruf",
    noCommune: "Keine Ergebnisse gefunden für",
    communeTypeList: "Proporzgemeinde",
    communeTypeSmall: "Majorzgemeinde",
    noDataAvailable: "Nicht mitgeteilt",
    footerTitle:
      "Hier finden Sie andere Gemeinden, die Sie interessieren könnten",
    lastUpdateDate: "Letztes Update",
    candidates: "Kandidaten",
    nationalities: {
      be: "Belgisch",
      fr: "Französisch",
      de: "Deutsch",
      it: "Italienisch",
      es: "Espagnol",
      lu: "Luxemburgisch",
      nl: "Niederländisch",
      pt: "Portugiesisch",
      gb: "Englisch",
      others: "Andere",
    },
    article: "Artikel",
    articleTitle: "Newsticker",
    articleForCommune: "Aktuelles an der Gemeinde",
    coalitionBigCommune: "Koalition",
    coalitionSmallCommune: "Schöffenrat",
    communeInDetail: "Zur Gemeinde",
    residents: "Einwohner",
    numberOfLocalities: "Anzahl der Ortschaften",
    incumbentMayor: "Amtierende(r) Bürgermeister(in)",
    typeOfCommune: "Wahlsystem",
    moreToTheCommune: "Mehr Daten zur Gemeinde",
    candidatesForTheCommune: "Kandidaten in der Gemeinde",
    electionInNumbers: "Die Wahl in Zahlen",
    candidatesWomen: "Weibliche Kandidaten",
    candidatesForeigners: "Nicht-luxemburgische Kandidaten",
    pollingStations: "Wahlbüros",
    pontetialVoters: "Anteil der potenziellen Wähler",
    seatsToBeFilled: "zu vergebende Sitze",
    communeInNumbers: "Alles über die Gemeinde",
    politic: "Politik",
    municipalCouncilTitle: "Sitzverteilung im Gemeinderat ",
    municipalCouncilTitleSmallCommune: "Ergebnisse der Wahlen von 2017",
    municipalCouncilDescriptionSmallCommune: "Daten in absoluten Zahlen",
    municipalCouncilDescription:
      "Daten nach den Kommunalwahlen 2023 in Anzahl der Sitze",
    municipalCouncilByGender: "Frauen und Männer in Gemeinderat",
    municipalCouncilByGenderDescription: "Angaben gültig am 1. Januar 2023",
    population: "Bevölkerung",
    populationTitle: "Bevölkerungsentwicklung in ",
    populationDescription:
      "Entwicklung der Einwohnerzahl zwischen 1983 und 2023",
    unemploymentTitle: "Arbeitslosenquote in ",
    unemploymentDescription:
      "Anteil der Arbeitslosen an der Erwerbsbevölkerung der Gemeinde am 1. Januar zwischen 2001 und 2023",
    nationalityTitle: "Bevölkerung nach Staatsangehörigkeit",
    nationalityDescription:
      "Anteil der fünf am stärksten vertretenen Nationalitäten, Stand: 1. Januar 2023",
    agePyramidTitle: "Einwohnerzahl nach Altersgruppen",
    agePyramidDescription: "Angaben am 1. Januar 2023",
    housing: "Wohnungsbau",
    housingPrice: "Immobilienpreise",
    housingPriceAverage: "Durchschnitt in der Gemeinde",
    housingNationalPriceAverage: "Landesdurchschnitt",
    housingAreaPurchased:
      "Leistbare Wohnfläche mit einem Budget von 500.000 Euro",
    housingVacantHousesPercentage: "Unbebaute Grundstücke in der Kommune",
    numberOfVotes: "Anzahl der abgegebenen Stimmen",
    votes: "Stimmen",
    isElected: "gewählte",
    isNotElected: "nicht gewählte",
    hasCandidate: "hat kandidiert",
    gender: {
      men: "Männer",
      women: "Frauen",
    },
    years: "Jahre",
    governingParty: "Regierende Partei",
    mayor: "Bürgermeister",
    alderman: "Schöffe",
    alderwoman: "Schöffin",
    references: [
      "Quelle: Bei der Gemeinde eingereichte Bewerbungen",
      "Quelle: Familienministerium",
      "Quelle: elections.public.lu",
      "Grafik: Luxemburger Wort",
      "Quelle: Statec",
    ],
    unemploymentRate: "Arbeitslosenquote",
    numberOfSeats: "Anzahl der Sitze",
    electionSystemChanged: "Seit 2023",
    searchMore: "nach Anderen Gemeinden suchen",
    electedCandidates: "Gewählte Kandidaten",
    results: "Resultate",
    votesPercentage: "Prozent der Stimmen",
    votesPercentageParty: "Prozent nach Partei",
    votesDifference: "Verteilung in Gemeinderat im Vergleich 2023 und 2017",
    lostVotes: "Verlorene(r) Sitz(e)",
    gainedVotes: "Gewonnene(r) Sitz(e)",
    coalitionOptions: "Welche Koalitionen sind möglich?",
    previousCandidacies: "Bisherige Kandidaturen",
    noCandidacies: "Keine Kandidatur",
    votesReceived: "Erzielte Stimmen",
    electedDirectly: "Direkt gewählt",
    numberCandidates: "Anzahl Kandidaten",
    seatsUpForElection: "Zu wählende Personen",
    councillor: "Gemeinderat",
    womenCouncillor: "Gemeinderätin",
    resultsUpdated: "Stand",
    resultsHour: "Uhr",
    votesDifferenceMessage:
      "Bei den Kommunalwahlen 2017 funktionierte die Gemeinde nach dem Majorzsystem. Grund dafür, dass die Grafik zu den Sitzgewinnen und -verlusten nicht angezeigt wird.",
  },
  en: {
    title: "Who is running for the municipal elections?",
    update: "Last update",
    filter: "Filter by party",
    communePlaceholder: "Enter a commune name",
    all: "All parties",
    seeAll: "SEE ALL",
    closeAll: "CLOSE ALL",
    or: "or",
    noDataList: "No list has yet been published",
    noDataSmall: "No list has yet been published",
    firstMandate: "First candidacy",
    age: "Age",
    function: "Function",
    nationality: "Nationality",
    occupation: "Occupation",
    noCommune: "No results found for",
    communeTypeList: "List ballot",
    communeTypeSmall: "List small ballot",
    noDataAvailable: "N/A",
    footerTitle: "Search for candidates in other municipalities",
    lastUpdateDate: "Last update",
    candidates: "Candidates",
    nationalities: {
      be: "Belgian",
      fr: "French",
      de: "Deutsch",
      it: "Italian",
      es: "Espagnol",
      lu: "Luxemburgisch",
      nl: "Niederländisch",
      pt: "Portugiesisch",
      gb: "Englisch",
      others: "Others",
    },
    article: "Article",
    articleTitle: "Newsticker",
    articleForCommune: "News of the municipalities",
    coalitionBigCommune: "Coalition",
    coalitionSmallCommune: "City council",
    communeInDetail: "The commune in detail",
    residents: "Residents",
    numberOfLocalities: "Number of localities",
    incumbentMayor: "Incumbent mayor",
    typeOfCommune: "Voting system",
    moreToTheCommune: "More info about the commune",
    candidatesForTheCommune: "Candidates in the running",
    electionInNumbers: "The election in numbers",
    candidatesWomen: "Female candidates",
    candidatesForeigners: "Non-Luxembourgish candidates",
    pollingStations: "Polling stations",
    pontetialVoters: "Proportion of registered potential voters",
    seatsToBeFilled: "Seats to be filled",
    communeInNumbers: "All about the commune",
    politic: "Politics",
    municipalCouncilTitle: "Distribution of seats in the municipal council ",
    municipalCouncilTitleSmallCommune: "Results of the 2017 election",
    municipalCouncilDescriptionSmallCommune:
      "Data expressed in absolute values",
    municipalCouncilDescription:
      "Data after the 2023 municipal elections in number of seats",
    municipalCouncilByGender: "Number of men and women in the communal council",
    municipalCouncilByGenderDescription: "Data valid as of 1 January 2023",
    population: "Population",
    populationTitle: "Evolution of the population in ",
    populationDescription:
      "Number of inhabitants in absolute value between 1 January 1983 and 1 January 2023",
    unemploymentTitle: "Unemployment rate in ",
    unemploymentDescription:
      "Share of unemployed persons in the active population of the municipality on 1 January between 2001 and 2023",
    nationalityTitle: "Population according to nationality",
    nationalityDescription:
      "Data expressed as a percentage on 1 January among the five most represented nationalities",
    agePyramidTitle: "Population by age group",
    agePyramidDescription: "Data as of January 1, 2023",
    housing: "Housing",
    housingPrice: "Property prices",
    housingPriceAverage: "Average price per m² in the commune",
    housingNationalPriceAverage: "National average",
    housingAreaPurchased:
      "Affordable living space with a budget of 500.000 Euros",
    housingVacantHousesPercentage: "Vacants lots in the commune",
    numberOfVotes: "Number of votes",
    votes: "Votes",
    isElected: "Elected",
    isNotElected: "Non-elected",
    hasCandidate: "has run for election",
    gender: {
      men: "Men",
      women: "Women",
    },
    years: "Years",
    governingParty: "Governing party",
    mayor: "Mayor",
    alderman: "Alderman",
    alderwoman: "Alderwoman",
    references: [
      "Source: Applications submitted to the commune",
      "Source: Ministry of Family Affairs",
      "Source: elections.public.lu",
      "Graphics: Contacto",
      "Source: Statec",
    ],
    unemploymentRate: "Unemployment rate",
    numberOfSeats: "Number of seats",
    electionSystemChanged: "Since 2023",
    searchMore: "search for other municipalities",
    results: "Results",
    votesPercentage: "Percentage of votes",
    votesPercentageParty: "Percent by party",
    votesDifference:
      "Distribution of seats in the communal council in 2023 compared to 2017",
    lostVotes: "Seat(s) lost",
    gainedVotes: "Seat(s) won",
    coalitionOptions: "Which coalitions are possible?",
    previousCandidacies: "Previous candidacies",
    noCandidacies: "No candidacy",
    votesReceived: "Votes received",
    electedDirectly: "Elected directly",
    numberCandidates: "Number of candidates",
    seatsUpForElection: "Seats up for election",
    councillor: "Communal councillor",
    womenCouncillor: "Communal councillor",
    resultsUpdated: "Stand",
    resultsHour: "",
    votesDifferenceMessage:
      "In the 2017 municipal elections, the municipality operated under the majority system. For this reason, the graph showing the gain and loss of seats is not displayed.",
  },
  pt: {
    title: "Quem se candidata às eleições comunais?",
    update: "Última atualização",
    filter: "Filtrar por partido",
    communePlaceholder: "Digite o nome de uma comunidade",
    all: "Todos os partidos",
    seeAll: "VER TUDO",
    closeAll: "FECHAR TUDO",
    or: "ou",
    noDataList: "Nenhuma lista foi publicada ainda",
    noDataSmall: "Não há dados para esta comunidade ainda",
    firstMandate: "Primeira candidatura",
    age: "Idade",
    function: "Função",
    nationality: "Nacionalidade",
    occupation: "Profissão",
    noCommune: "Nenhum resultado encontrado para",
    communeTypeList: "Proporzgemeng",
    communeTypeSmall: "Majorzgemeng",
    noDataAvailable: "Não disponível",
    footerTitle:
      "Procure por candidatos em outras comunidades que possam interessar-lhe",
    lastUpdateDate: "Última atualização",
    candidates: "Candidatos",
    nationalities: {
      be: "Belga",
      fr: "Francês",
      de: "Alemão",
      it: "Italiano",
      es: "Espanhol",
      lu: "Luxemburguês",
      nl: "Holandês",
      pt: "Português",
      gb: "Inglês",
      others: "Outros",
    },
    article: "Artigo",
    articleTitle: "Newsticker",
    articleForCommune: "Notícias das comunidades",
    coalitionBigCommune: "Coligação",
    coalitionSmallCommune: "Conselho municipal",
    communeInDetail: "A comuna em detalhe",
    residents: "Habitantes",
    numberOfLocalities: "Número de localidades",
    incumbentMayor: "Burgomestre atual",
    typeOfCommune: "Sistema eleitoral",
    moreToTheCommune: "Mais dados sobre as comunas",
    candidatesForTheCommune: "Os candidatos em competição",
    electionInNumbers: "As eleições em números",
    candidatesWomen: "Mulheres candidatas",
    candidatesForeigners: "Candidatos não luxemburgueses",
    pollingStations: "Postos de votação",
    pontetialVoters: "Proporção de potenciais eleitores registados",
    seatsToBeFilled: "Assentos a preencher",
    communeInNumbers: "Tudo sobre a cidade",
    politic: "Política",
    municipalCouncilTitle: "Repartição dos lugares no conselho comunal ",
    municipalCouncilTitleSmallCommune: "Resultados das eleições de 2017",
    municipalCouncilDescriptionSmallCommune:
      "Dados expressos em valores absolutos",
    municipalCouncilDescription:
      "Dados após as eleições municipais de 2023 em número de assentos",
    municipalCouncilByGender:
      "Número de homens e mulheres no conselho municipal",
    municipalCouncilByGenderDescription:
      "Dados válidos a partir de 1 de Janeiro de 2023",
    population: "População",
    populationTitle: "Evolução população em ",
    populationDescription:
      "Número de habitantes em valor absoluto entre 1 de janeiro de 1983 e 1 de janeiro de 2023",
    unemploymentTitle: "Taxa de desemprego na Comuna ",
    unemploymentDescription:
      "Percentagem de desempregados na população ativa do concelho a 1 de janeiro entre 2001 e 2023",
    nationalityTitle: "População por nacionalidade",
    nationalityDescription:
      "Dados expressos em percentagem em 1 de Janeiro entre as cinco nacionalidades mais representadas",
    agePyramidTitle: "População por faixa etária",
    agePyramidDescription: "Dados a 1 de Janeiro de 2023",
    housing: "Habitação",
    housingPrice: "Preço do imobiliário",
    housingPriceAverage: "Preço médio m² na comuna",
    housingNationalPriceAverage: "Média nacional",
    housingAreaPurchased: "Área disponível para um orçamento de 500.000 Euros",
    housingVacantHousesPercentage: "Lotes disponíveis na comuna",
    numberOfVotes: "Número de votos",
    votes: "Votos",
    isElected: "Eleito",
    isNotElected: "Não eleito",
    hasCandidate: "foi candidato",
    gender: {
      men: "Homens",
      women: "Mulheres",
    },
    years: "Anos",
    governingParty: "Partido no poder",
    mayor: "Presidente da Câmara",
    alderman: "Vereador",
    alderwoman: "Vereadora",
    references: [
      "Fonte: Candidaturas apresentadas ao município",
      "Fonte: Ministério da Família",
      "Fonte: elections.public.lu",
      "Gráficos: Contacto",
      "Fonte: Statec",
    ],
    unemploymentRate: "Taxa de desemprego",
    numberOfSeats: "Número de lugares",
    electionSystemChanged: "Desde 2023",
    searchMore: "pesquisar outra comunidade",
    results: "Resultados",
    votesPercentage: "Percentagem de votos",
    votesPercentageParty: "Percentagem de votos por partido",
    votesDifference:
      "Distribuição dos lugares no conselho comunal em 2023 em comparação com 2017",
    lostVotes: "Perda de lugares",
    gainedVotes: "Ganho de lugares",
    coalitionOptions: "Que coligações são possíveis?",
    previousCandidacies: "Candidaturas anteriores",
    noCandidacies: "Nenhuma candidatura",
    votesReceived: "Votos obtidos",
    electedDirectly: "Eleito diretamente",
    numberCandidates: "Número de candidatos",
    seatsUpForElection: "Pessoas a eleger",
    councillor: "Conselheiro comunal",
    womenCouncillor: "Conselheira comunal",
    resultsUpdated: "Stand",
    resultsHour: "",
    votesDifferenceMessage:
      "Nas eleições municipais de 2017, o município funcionou segundo o sistema maioritário. Por este motivo, não é apresentado o gráfico que mostra o ganho e a perda de lugares.",
  },
};
